import script from "./subscription-selection.vue?vue&type=script&setup=true&lang=ts"
export * from "./subscription-selection.vue?vue&type=script&setup=true&lang=ts"

import "./subscription-selection.vue?vue&type=style&index=0&id=59548e0b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59548e0b"]])

export default __exports__